import { useContext } from 'react';

import DeribitIcon from '../../../../../assets/icons/deribit-icon.svg';
import OkxIcon from '../../../../../assets/icons/okx-icon.svg';
import OtcIcon from '../../../../../assets/icons/otc-icon.svg';
import { PortfolioManagementContext } from '../../../../../providers/portfolio-management';
import { IAccountOption, VenueContext } from '../../../../../providers/venue-provider';
import {
  AggregatedExchangeAccountList,
  AggregatedAlphabeticalAccountList,
  AggregatedOTCAccountList,
} from '../../../../shared/aggregated-accounts-list';

type PortfolioListAggregatedProps = {
  isPortfolioSidebarOpen: boolean;
  selectedAccountsAggregated?: IAccountOption[];
  setSelectedAccountsAggregated?: React.Dispatch<React.SetStateAction<any[]>>;
};

export const PortfolioListAggregated = ({
  isPortfolioSidebarOpen,
}: PortfolioListAggregatedProps) => {
  const { credentials } = useContext(VenueContext);
  const {
    selectedAccountsAggregated,
    setSelectedAccountsAggregated,
    generalSettingsSelected,
    isNamesBlurred,
  } = useContext(PortfolioManagementContext);

  return (
    <>
      {generalSettingsSelected.accountListing === 'byExchange' ? (
        <>
          <AggregatedExchangeAccountList
            exchange="deribit"
            label="Deribit"
            icon={DeribitIcon}
            credentials={credentials}
            isPortfolioSidebarOpen={isPortfolioSidebarOpen}
            selectedAccountsAggregated={selectedAccountsAggregated}
            setSelectedAccountsAggregated={setSelectedAccountsAggregated}
            isBlurred={isNamesBlurred}
          />
          <AggregatedExchangeAccountList
            exchange="okx"
            label="OKX"
            icon={OkxIcon}
            credentials={credentials}
            isPortfolioSidebarOpen={isPortfolioSidebarOpen}
            selectedAccountsAggregated={selectedAccountsAggregated}
            setSelectedAccountsAggregated={setSelectedAccountsAggregated}
            isBlurred={isNamesBlurred}
          />
          <AggregatedOTCAccountList
            exchange="otc"
            label="OTC"
            icon={OtcIcon}
            credentials={credentials}
            isPortfolioSidebarOpen={isPortfolioSidebarOpen}
            selectedAccountsAggregated={selectedAccountsAggregated}
            setSelectedAccountsAggregated={setSelectedAccountsAggregated}
            isBlurred={isNamesBlurred}
          />
        </>
      ) : (
        <AggregatedAlphabeticalAccountList
          credentials={credentials}
          isPortfolioSidebarOpen={isPortfolioSidebarOpen}
          selectedAccountsAggregated={selectedAccountsAggregated}
          setSelectedAccountsAggregated={setSelectedAccountsAggregated}
          isBlurred={isNamesBlurred}
        />
      )}
    </>
  );
};
